import {tracking as barkTrackingLogEvent, _t} from "@bark/bark-core";

export default function(eventEmitter){

	const {Handlebars} = window;

	const sortContainerId = 'list-sort-container';

	const sortSelectedId = 'list-sort-selected';

	const sortSelectItemsId = 'list-sort-select-items';

	const sortSelectTemplate = Handlebars.compile(document.getElementById('list-sort-select-template').innerHTML);

	const sortOptions = [
        {title: _t('buyer_seller-list:sort.best-match'), value: 'best', selected: false},
        {title: _t('buyer_seller-list:sort.rating'), value: 'review', selected: false},
        {title: _t('buyer_seller-list:sort.response-time'), value: 'resp_time', selected: false},
        {title: _t('buyer_seller-list:sort.distance'), value: 'distance', selected: false, countryIds: [236]}
    ];

	const state = {
		buyerCountryId: null
	};

	const draw = (data) => {
		buildComponent();
		bindListners();
	};

	const buildComponent = () => {
		let sortOptionsForCountry = showInBuyerCountry(sortOptions);
		let sortSelectHtml = sortSelectTemplate({sortOptionsForCountry, sortSelectedId, sortSelectItemsId});
		$(`#${sortContainerId}`).empty().append(sortSelectHtml);
	};

	const bindListners = () => {

    	$(`#${sortSelectItemsId} .filter-select-option`).off('click').on('click', function (e) {
            e.preventDefault();
            if(!$(this).hasClass("selected")){
            	let sortValue = $(this).data('sortValue');
            	let sortText = $.trim($(this).text());
            	window.rqfa.setShouldNotRQFA(false);
                setSelectedSort(sortValue);
                eventEmitter.emit('sort.changed',{newSort: sortValue});

                barkTrackingLogEvent(
                	'seller-list-&-profile',
                	`Sort by ${sortText}`,
                	{project_id: getProjectHash(), sortType: sortValue}
            	);
            }
        });

        $(`#${sortSelectedId}`).off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".filter-select-items").removeClass('d-block');
            $(`#${sortSelectItemsId}`).addClass('d-block');
        });
	};

	const setSelectedSortText = () => {
		let selected = sortOptions.filter(option => option.selected);
		$(`#${sortSelectedId}`).empty().append(_t('buyer_seller-list:sort.sort-by-method', {'sort_method': selected[0].title}));
	};

	const setSelectedSort = (sortValue) => {
		sortOptions.forEach((option, index) => {
			if(sortValue === option.value){
				sortOptions[index].selected = true;
			}else {
				sortOptions[index].selected = false;
			}
		});

		draw();
		setSelectedSortText();
	};

	const setBuyerCountryId = ({data: {country_id}}) => {
		state.buyerCountryId = country_id;
	};

	const showInBuyerCountry = (sortOptions) => {
		return sortOptions.filter((option, index) => {
			if(state.buyerCountryId && (option?.countryIds?.length > 0)){
				return option.countryIds.includes(state.buyerCountryId);
			}
			return true;
		});
	};

	const getProjectHash = () => {
        return $('#project-id').val();
    };

	return {
		setSelectedSort,
		setBuyerCountryId
    };

}
